// /* eslint-disable no-undef */
// import React, { useEffect, useRef, useState } from "react";
// import styles from "../Assets/css/fleet.module.css";

// import { Loader } from "@googlemaps/js-api-loader";

// const Map = ({ data }) => {
//   const [selectedDeviceType, setSelectedDeviceType] = useState("All");
//   const mapContainerRef = useRef(null);
//   const [map, setMap] = useState(null);
//   const [markers, setMarkers] = useState([]);
//   const [infoWindow, setInfoWindow] = useState(null);

//   const handleSelectChange = (event) => {
//     const selectedValue = event.target.value;
//     setSelectedDeviceType(selectedValue);
//   };

//   useEffect(() => {
//     const loader = new Loader({
//       apiKey: "",
//       version: "weekly",
//     });

//     loader.load().then(() => {
//       const newMap = new google.maps.Map(mapContainerRef.current, {
//         center: { lat: 41.5, lng: -100.0 },
//         zoom: 4,
//       });
//       setMap(newMap);

//       const newInfoWindow = new google.maps.InfoWindow();
//       setInfoWindow(newInfoWindow);
//     });
//   }, []);

//   useEffect(() => {
//     if (map && infoWindow) {
//       const getColor = (deviceType) => {
//         switch (deviceType.toLowerCase()) {
//           case "thermostat":
//             return "blue";
//           case "battery":
//             return "red";
//           case "vehicle":
//             return "green";
//           default:
//             return "orange";
//         }
//       };
//       const filteredData =
//         selectedDeviceType === "All"
//           ? data.filter(
//               (device) =>
//                 device.address[0]?.latitude && device.address[0]?.longitude
//             )
//           : data.filter(
//               (device) =>
//                 device.device_type
//                   .toLowerCase()
//                   .replace(/\s+/g, "")
//                   .replace(/^(.)/, (match, p1) => p1.toUpperCase()) ===
//                   selectedDeviceType &&
//                 device.address[0]?.latitude &&
//                 device.address[0]?.longitude
//             );
//       const locations = filteredData.map((device) => ({
//         device_name: device.name,
//         lat: parseFloat(device.address[0]?.latitude),
//         lng: parseFloat(device.address[0]?.longitude),
//         color: getColor(device.device_type),
//       }));

//       console.log(locations);
//       markers.forEach((marker) => {
//         marker.setMap(null); // Remove marker from the map
//       });
//       // Function to add markers
//       const addMarkers = (locations) => {
//         const newMarkers = locations.map((location, index) => {
//           const marker = new google.maps.Marker({
//             position: {
//               lat: parseFloat(location.lat),
//               lng: parseFloat(location.lng),
//             },
//             map: map,
//             icon: {
//               path: google.maps.SymbolPath.CIRCLE, // Shape of the marker
//               fillColor: location.color, // Color of the marker
//               fillOpacity: 1, // Opacity of the marker
//               strokeWeight: 0, // Stroke weight of the marker
//               scale: 10,
//             },
//             info: location.device_name, // Example info
//           });

//           marker.addListener("click", () => {
//             infoWindow.setContent(marker.info);
//             infoWindow.open(map, marker);
//             // map.setZoom(10);
//             map.setCenter(marker.getPosition()); // Center the map on the clicked marker
//           });

//           return marker;
//         });
//         setMarkers(newMarkers);
//       };
//       addMarkers(locations);
//     }
//   }, [map, infoWindow, data, selectedDeviceType]);

//   return (
//     <>
//       <select
//         className={styles.customs_elect}
//         value={selectedDeviceType}
//         onChange={handleSelectChange}
//       >
//         <option value="All">All</option>
//         {Array.from(
//           new Set(data.map((device) => device.device_type.toLowerCase()))
//         ).map((deviceType) => (
//           <option
//             key={deviceType.charAt(0).toUpperCase() + deviceType.slice(1)}
//             value={deviceType.charAt(0).toUpperCase() + deviceType.slice(1)}
//           >
//             {deviceType === "inverter"
//               ? "Solar"
//               : deviceType.charAt(0).toUpperCase() + deviceType.slice(1)}
//           </option>
//         ))}
//         <option value="Franklin">Franklin</option>
//       </select>

//       <div ref={mapContainerRef} style={{ width: "100%", height: "393px" }} />
//     </>
//   );
// };

// export default Map;
/* eslint-disable no-undef */
/* eslint-disable no-undef */

import React, { useEffect, useRef, useState } from "react";
import styles from "../Assets/css/fleet.module.css";
import { Loader } from "@googlemaps/js-api-loader";

const USA_BOUNDS = {
  north: 52,
  south: 24,
  west: -125.0,
  east: -66.5,
};

// US State center coordinates and zoom levels
const STATE_COORDINATES = {
  "Alabama": { lat: 32.806671, lng: -86.791130, zoom: 7 },
  "Alaska": { lat: 61.370716, lng: -152.404419, zoom: 4 },
  "Arizona": { lat: 33.729759, lng: -111.431221, zoom: 7 },
  "Arkansas": { lat: 34.969704, lng: -92.373123, zoom: 7 },
  "California": { lat: 36.116203, lng: -119.681564, zoom: 6 },
  "Colorado": { lat: 39.059811, lng: -105.311104, zoom: 7 },
  "Connecticut": { lat: 41.597782, lng: -72.755371, zoom: 9 },
  "Delaware": { lat: 39.318523, lng: -75.507141, zoom: 9 },
  "Florida": { lat: 27.766279, lng: -81.686783, zoom: 6 },
  "Georgia": { lat: 33.040619, lng: -83.643074, zoom: 7 },
  "Hawaii": { lat: 21.094318, lng: -157.498337, zoom: 7 },
  "Idaho": { lat: 44.240459, lng: -114.478828, zoom: 6 },
  "Illinois": { lat: 40.349457, lng: -88.986137, zoom: 7 },
  "Indiana": { lat: 39.849426, lng: -86.258278, zoom: 7 },
  "Iowa": { lat: 42.011539, lng: -93.210526, zoom: 7 },
  "Kansas": { lat: 38.526600, lng: -96.726486, zoom: 7 },
  "Kentucky": { lat: 37.668140, lng: -84.670067, zoom: 7 },
  "Louisiana": { lat: 31.169546, lng: -91.867805, zoom: 7 },
  "Maine": { lat: 44.693947, lng: -69.381927, zoom: 7 },
  "Maryland": { lat: 39.063946, lng: -76.802101, zoom: 8 },
  "Massachusetts": { lat: 42.230171, lng: -71.530106, zoom: 8 },
  "Michigan": { lat: 43.326618, lng: -84.536095, zoom: 6 },
  "Minnesota": { lat: 45.694454, lng: -93.900192, zoom: 6 },
  "Mississippi": { lat: 32.741646, lng: -89.678696, zoom: 7 },
  "Missouri": { lat: 38.456085, lng: -92.288368, zoom: 7 },
  "Montana": { lat: 46.921925, lng: -110.454353, zoom: 6 },
  "Nebraska": { lat: 41.125370, lng: -98.268082, zoom: 7 },
  "Nevada": { lat: 38.313515, lng: -117.055374, zoom: 6 },
  "New Hampshire": { lat: 43.452492, lng: -71.563896, zoom: 8 },
  "New Jersey": { lat: 40.298904, lng: -74.521011, zoom: 10 },
  "New Mexico": { lat: 34.840515, lng: -106.248482, zoom: 7 },
  "New York": { lat: 42.165726, lng: -74.948051, zoom: 7 },
  "North Carolina": { lat: 35.630066, lng: -79.806419, zoom: 7 },
  "North Dakota": { lat: 47.528912, lng: -99.784012, zoom: 7 },
  "Ohio": { lat: 40.388783, lng: -82.764915, zoom: 7 },
  "Oklahoma": { lat: 35.565342, lng: -96.928917, zoom: 7 },
  "Oregon": { lat: 44.572021, lng: -122.070938, zoom: 7 },
  "Pennsylvania": { lat: 40.590752, lng: -77.209755, zoom: 7 },
  "Rhode Island": { lat: 41.680893, lng: -71.511780, zoom: 10 },
  "South Carolina": { lat: 33.856892, lng: -80.945007, zoom: 7 },
  "South Dakota": { lat: 44.299782, lng: -99.438828, zoom: 7 },
  "Tennessee": { lat: 35.747845, lng: -86.692345, zoom: 7 },
  "Texas": { lat: 31.054487, lng: -97.563461, zoom: 6 },
  "Utah": { lat: 40.150032, lng: -111.862434, zoom: 7 },
  "Vermont": { lat: 44.045876, lng: -72.710686, zoom: 8 },
  "Virginia": { lat: 37.769337, lng: -78.169968, zoom: 7 },
  "Washington": { lat: 47.400902, lng: -121.490494, zoom: 7 },
  "West Virginia": { lat: 38.491226, lng: -80.954453, zoom: 7 },
  "Wisconsin": { lat: 44.268543, lng: -89.616508, zoom: 7 },
  "Wyoming": { lat: 42.755966, lng: -107.302490, zoom: 7 }
};

const Map = ({
  data,
  franklinData,
  unifiedDevices = [],
  selectedState = "All",
  selectedUtility = "All",
  utilities = []
}) => {
  const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
  const [selectedDeviceType, setSelectedDeviceType] = useState("All");
  const mapContainerRef = useRef(null);
  const searchInputRef = useRef(null);
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [infoWindow, setInfoWindow] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const [weatherData, setWeatherData] = useState(null);
  const [searchedLocation, setSearchedLocation] = useState(null);

  const handleSelectChange = (event) => {
    setSelectedDeviceType(event.target.value);
  };

  // Fetch weather data for a given location
  const fetchWeatherData = async (lat, lng, locationName) => {
    try {
      const WEATHER_API_KEY = process.env.REACT_APP_WEATHER_API_KEY;

      // Using WeatherAPI.com
      const response = await fetch(
        `https://api.weatherapi.com/v1/current.json?key=${WEATHER_API_KEY}&q=${lat},${lng}&aqi=no`
      );

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          throw new Error("Invalid API key. Please check your WeatherAPI key.");
        }
        throw new Error(`Failed to fetch weather data: ${response.status}`);
      }

      const data = await response.json();
      setWeatherData({
        temp: Math.round(data.current.temp_f),
        feelsLike: Math.round(data.current.feelslike_f),
        condition: data.current.condition.text,
        description: data.current.condition.text.toLowerCase(),
        humidity: data.current.humidity,
        windSpeed: Math.round(data.current.wind_mph),
        icon: data.current.condition.icon,
        error: false,
      });
      setSearchedLocation(locationName);
      console.log("Weather Data:", data);
    } catch (error) {
      console.error("Error fetching weather data:", error);
      // Show error in weather card
      setWeatherData({
        temp: "--",
        feelsLike: "--",
        condition: "Error",
        description: error.message || "Unable to fetch weather data",
        humidity: "--",
        windSpeed: "--",
        icon: "",
        error: true,
      });
      setSearchedLocation(locationName);
    }
  };



  // Load Google Maps + Places library
  useEffect(() => {
    const loader = new Loader({
      apiKey: GOOGLE_MAP_API_KEY,
      version: "weekly",
      libraries: ["places"], // Important: Load Places library
    });

    loader.load().then(() => {
      // USA bounds - strictly limited to contiguous United States



      const newMap = new google.maps.Map(mapContainerRef.current, {
        center: { lat: 39.8, lng: -98.6 },
        zoom: 0,
        minZoom: 0,
        maxZoom: 18,
        restriction: {
          latLngBounds: USA_BOUNDS,
          strictBounds: true,
        },
        gestureHandling: "greedy",
        mapTypeControl: true,
        streetViewControl: true,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_LEFT, // ← This moves it!
        },
        fullscreenControl: true,
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_RIGHT, // ← This moves it!
        },
      });

      // Fit the map to USA bounds on load
      // newMap.fitBounds(usaBounds);

      setMap(newMap);
      setInfoWindow(new google.maps.InfoWindow());

      // Initialize Autocomplete on the search input (restricted to countries)
      const input = searchInputRef.current;
      const auto = new google.maps.places.Autocomplete(input, {
        types: ["geocode", "establishment"],
        fields: ["place_id", "geometry", "name", "formatted_address"],
      });

      // Restrict to countries only (optional but cleaner)
      auto.setComponentRestrictions({ country: ["us"] });
      auto.addListener("place_changed", () => {
        const place = auto.getPlace();

        if (!place.geometry || !place.geometry.viewport) {
          console.log("No geometry for this place");
          return;
        }

        // Fetch weather data for the searched location
        const location = place.geometry.location;
        fetchWeatherData(
          location.lat(),
          location.lng(),
          place.formatted_address || place.name
        );

        // Zoom and center the map to the selected country
        if (place.geometry.viewport) {
          newMap.fitBounds(place.geometry.viewport);
        } else {
          newMap.setCenter(place.geometry.location);
          newMap.setZoom(25);
        }

        // Optional: Slight delay to ensure bounds are applied
        setTimeout(() => {
          if (newMap.getZoom() > 20) newMap.setZoom(20); // Prevent too much zoom for large countries
        }, 500);
      });

      setAutocomplete(auto);
    });
  }, []);

  // Center map on selected state
  useEffect(() => {
    if (!map) return;

    if (selectedState && selectedState !== "All" && STATE_COORDINATES[selectedState]) {
      const stateCoords = STATE_COORDINATES[selectedState];
      map.setCenter({ lat: stateCoords.lat, lng: stateCoords.lng });
      map.setZoom(stateCoords.zoom);
    } else if (selectedState === "All") {
      // Reset to USA view
      map.setCenter({ lat: 39.8, lng: -98.6 });
      map.setZoom(3);
    }
  }, [map, selectedState]);

  useEffect(() => {
    if (!map || !infoWindow) return;

    // Color mapping
    const getColor = (type) => {
      const t = type?.toLowerCase();
      if (t.includes("thermostat")) return "#4285F4"; // Blue
      if (t.includes("battery")) return "#EA4335"; // Red
      if (t.includes("vehicle")) return "#34A853"; // Green
      if (t.includes("franklin")) return "#9E9E9E"; // Gray
      if (t.includes("hoymiles")) return "#FF9800"; // Orange
      if (t.includes("sol-ark")) return "#9C27B0"; // Purple
      return "#FBBC05"; // Yellow (default)
    };

    let filteredData = [];

    if (selectedDeviceType === "All") {
      // 1. Texture Devices (Thermostat, Battery, etc.)
      const textureDevices = data
        .filter((d) => (d.owner_address?.latitude && d.owner_address?.longitude) || (d.address?.[0]?.latitude && d.address?.[0]?.longitude))
        .map((d) => ({
          name: d.name || "Unknown Device",
          lat: parseFloat(d.owner_address?.latitude || d.address?.[0]?.latitude),
          lng: parseFloat(d.owner_address?.longitude || d.address?.[0]?.longitude),
          type: d.device_type || "unknown",
          state: d.owner_address?.state || d.address?.[0]?.state,
          zip: d.owner_address?.zip_code || d.address?.[0]?.zip_code
        }));

      // 2. FranklinWH Devices
      const franklinDevices = (franklinData || [])
        .filter((d) => d.latitude && d.longitude)
        .map((d) => ({
          name: d.name || "FranklinWH Device",
          lat: parseFloat(d.latitude),
          lng: parseFloat(d.longitude),
          type: "franklinwh",
          state: null
        }));

      // 3. Unified Devices: Sol-Ark, Hoymiles & Franklin
      const unified = (unifiedDevices || [])
        .filter(
          (d) =>
            d.lat && d.lon && (d.type === "Sol-Ark" || d.type === "Hoymiles" || d.type === "Franklin")
        )
        .map((d) => ({
          name: d.name || d.device_id,
          lat: parseFloat(d.lat),
          lng: parseFloat(d.lon),
          type: d.type === "Sol-Ark" ? "sol-ark" : d.type === "Hoymiles" ? "hoymiles" : "franklin",
          state: null
        }));

      filteredData = [...textureDevices, ...franklinDevices, ...unified];
    } else if (
      selectedDeviceType === "FranklinWH" ||
      selectedDeviceType === "franklinwh"
    ) {
      filteredData = (franklinData || [])
        .filter((d) => d.latitude && d.longitude)
        .map((d) => ({
          name: d.name || "FranklinWH",
          lat: parseFloat(d.latitude),
          lng: parseFloat(d.longitude),
          type: "franklinwh",
          state: null
        }));
    } else if (selectedDeviceType === "Sol-Ark") {
      filteredData = unifiedDevices
        .filter((d) => d.type === "Sol-Ark" && d.lat && d.lon)
        .map((d) => ({
          name: d.name || "Sol-Ark",
          lat: parseFloat(d.lat),
          lng: parseFloat(d.lon),
          type: "sol-ark",
          state: null
        }));
    } else if (selectedDeviceType === "Hoymiles") {
      filteredData = unifiedDevices
        .filter((d) => d.type === "Hoymiles" && d.lat && d.lon)
        .map((d) => ({
          name: d.name || "Hoymiles",
          lat: parseFloat(d.lat),
          lng: parseFloat(d.lon),
          type: "hoymiles",
          state: null
        }));
    } else if (selectedDeviceType === "Franklin") {
      filteredData = unifiedDevices
        .filter((d) => d.type === "Franklin" && d.lat && d.lon)
        .map((d) => ({
          name: d.name || "Franklin",
          lat: parseFloat(d.lat),
          lng: parseFloat(d.lon),
          type: "franklin",
          state: null
        }));
    } else {
      // Other device types from main data
      filteredData = data
        .filter((d) => {
          const type = d.device_type?.toLowerCase();
          return (
            type === selectedDeviceType.toLowerCase() &&
            ((d.owner_address?.latitude && d.owner_address?.longitude) || (d.address?.[0]?.latitude && d.address?.[0]?.longitude))
          );
        })
        .map((d) => ({
          name: d.name || "Device",
          lat: parseFloat(d.owner_address?.latitude || d.address?.[0]?.latitude),
          lng: parseFloat(d.owner_address?.longitude || d.address?.[0]?.longitude),
          type: d.device_type,
          state: d.owner_address?.state || d.address?.[0]?.state,
          zip: d.owner_address?.zip_code || d.address?.[0]?.zip_code
        }));
    }

    if (selectedState !== "All") {
      filteredData = filteredData.filter(item =>
        item.state && item.state.toLowerCase() === selectedState.toLowerCase()
      );
    }

    if (selectedUtility !== "All") {
      const utility = utilities.find((u) => u.id.toString() === selectedUtility);
      if (utility && utility.zipcodes) {
        const allowedZips = utility.zipcodes.map((z) =>
          typeof z === "string" ? z : z.zip_code
        );
        filteredData = filteredData.filter(
          (item) => item.zip && allowedZips.includes(item.zip)
        );
      }
    }

    // Filter by USA Bounds
    filteredData = filteredData.filter(item =>
      item.lat <= USA_BOUNDS.north &&
      item.lat >= USA_BOUNDS.south &&
      item.lng >= USA_BOUNDS.west &&
      item.lng <= USA_BOUNDS.east
    );

    // Clear old markers
    markers.forEach((m) => m.setMap(null));
    setMarkers([]);

    // Add new markers
    const newMarkers = filteredData.map((item) => {
      const marker = new google.maps.Marker({
        position: { lat: item.lat, lng: item.lng },
        map,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: getColor(item.type),
          fillOpacity: 0.9,
          strokeColor: "#fff",
          strokeWeight: 2,
          scale: 11,
        },
        title: item.name,
      });

      marker.addListener("click", () => {
        infoWindow.setContent(
          `<div style="font-family: Arial; padding: 5px;">
            <strong>${item.name}</strong><br/>
            <small style="color: #666;">${item.type.replace(/-/g, " ")}</small>
          </div>`
        );
        infoWindow.open(map, marker);
      });

      return marker;
    });

    setMarkers(newMarkers);

    // Auto fit map to show all markers
    if (newMarkers.length > 0) {
      const bounds = new google.maps.LatLngBounds();
      newMarkers.forEach((m) => bounds.extend(m.getPosition()));
      map.fitBounds(bounds);
      // Prevent too much zoom
      if (map.getZoom() > 16) map.setZoom(16);
    }
  }, [map, infoWindow, data, franklinData, unifiedDevices, selectedDeviceType, selectedState, selectedUtility, utilities]);


  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 10,
          left: "clamp(44px, 23vw, 110px)",
          transform: "translateX(-50%)",
          zIndex: 10,
          background: "white",
          boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
          height: "36px",
          width: "200px",
          maxWidth: "90%",
          display: "flex",
          alignItems: "center",
          borderRadius: "3px",
          outline: "none",
          backgroundColor: "#fff7e9",
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#5f6368"
          strokeWidth="2.5"
          style={{ marginRight: "10px", flexShrink: 0, marginLeft: "10px" }}
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
        <input
          ref={searchInputRef}
          type="text"
          placeholder="Search Address "
          style={{
            width: "100%",
            padding: "10px",
            border: "none",
            height: "34px",
            outline: "none",
            fontSize: "16px",
            borderRadius: "4px",
            backgroundColor: "transparent",
          }}
        />
      </div>

      {/* Weather Information Card */}
      {weatherData && (
        <div
          style={{
            position: "absolute",
            top: 55,
            left: "clamp(44px, 23vw, 110px)",
            transform: "translateX(-50%)",
            zIndex: 10,
            background: weatherData.error
              ? "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
              : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            padding: "12px 16px",
            borderRadius: "8px",
            width: "200px",
            maxWidth: "90%",
            color: "white",
            fontFamily: "Arial, sans-serif",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
            <div>
              <div style={{ fontSize: "11px", opacity: 0.9, marginBottom: "2px" }}>
                {searchedLocation?.split(",")[0] || "Location"}
              </div>
              <div style={{ fontSize: "28px", fontWeight: "bold", lineHeight: "1" }}>
                {weatherData.temp}{weatherData.error ? "" : "°F"}
              </div>
            </div>
            {!weatherData.error && weatherData.icon && (
              <img
                src={weatherData.icon.startsWith('http') ? weatherData.icon : `https:${weatherData.icon}`}
                alt={weatherData.description}
                style={{ width: "50px", height: "50px", marginTop: "-5px" }}
              />
            )}
          </div>
          <div style={{ fontSize: "13px", textTransform: "capitalize", marginBottom: "8px", opacity: 0.95 }}>
            {weatherData.description}
          </div>
          {!weatherData.error && (
            <>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: "11px", opacity: 0.9 }}>
                <div>
                  <span style={{ opacity: 0.8 }}>Feels like:</span> {weatherData.feelsLike}°F
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: "11px", opacity: 0.9, marginTop: "4px" }}>
                <div>
                  <span style={{ opacity: 0.8 }}>💧</span> {weatherData.humidity}%
                </div>
                <div>
                  <span style={{ opacity: 0.8 }}>💨</span> {weatherData.windSpeed} mph
                </div>
              </div>
            </>
          )}
          <button
            onClick={() => setWeatherData(null)}
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
              background: "rgba(255,255,255,0.2)",
              border: "none",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              color: "white",
              cursor: "pointer",
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
            }}
          >
            ×
          </button>
        </div>
      )}




      <select
        className={styles.customs_elect}
        value={selectedDeviceType}
        onChange={handleSelectChange}
      >
        <option value="All">All Devices</option>

        {/* Main device types */}
        {Array.from(
          new Set(data.map((d) => d.device_type).filter(Boolean))
        ).map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}

        {/* Special ones */}
        <option value="FranklinWH">FranklinWH</option>
        <option value="Sol-Ark">Sol-Ark</option>
        <option value="Hoymiles">Hoymiles</option>
        <option value="Franklin">Franklin</option>
      </select>

      <div
        ref={mapContainerRef}
        style={{
          width: "100%",
          height: "393px",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      />
    </>
  );
};

export default Map;
